module.exports = __webpack_public_path__ + "images/category_lp/hobby/main-bg_d5fd417ff48f4c2c5ee7926e3d89358b.png";